import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
import General from './General';
import InterRactAccount from './InteractAccount';
import InteractFriend from './InteractFriend';
import Error404 from './Pages/404';
import Login from './Auth/Login';
import Register from './Auth/Register';
import ModifyAccount from './modifyAccount';
import InteractGroup from './InteractGroup';
import InitAllEvent from 'components/InitAllEvent';
import InteractPage from './InteractPage';
// import InteractAuto from './InteractAuto';
import DocumentManual from './DocumentManual';
import InteractReels from './InteractReels';

// import ForgotPasswordPage from "./Auth/ForgotPassword";

const Routes = () => {
    const { authUser } = useSelector(({ auth }) => auth);
    const location = useLocation();

    if (location.pathname === '' || location.pathname === '/') {
        return <Redirect to={'/general/manage-account-facebook'} />;
    } else if (authUser && location.pathname === '/signin') {
        return <Redirect to={'/general/manage-account-facebook'} />;
    }

    return (
        <React.Fragment>
            <Switch>
                <Route path="/signin" component={Login} />
                <Route path="/signup" component={Register} />
                {/* <Route path="/forgot-password" component={ForgotPasswordPage} /> */}
                {!authUser ? (
                    <Redirect to="/signin" />
                ) : (
                    <InitAllEvent>
                        <Switch>
                            <Route path="/general" component={General} />
                            <Route path="/interact" component={InterRactAccount} />
                            <Route path="/interactFriend" component={InteractFriend} />
                            <Route path="/modifyAccount" component={ModifyAccount} />
                            <Route path="/interactGroup" component={InteractGroup} />
                            <Route path="/interactPage" component={InteractPage} />
                            <Route path="/interact-reels" component={InteractReels} />
                            {/* <Route path="/interactAuto" component={InteractAuto} /> */}
                            <Route path="/document" component={DocumentManual} />
                        </Switch>
                    </InitAllEvent>
                )}
                <Route component={Error404} />
            </Switch>
        </React.Fragment>
    );
};

export default Routes;
